// IMPORT
import React from "react";

// CSS
import './Solutions.css';

// Components
import CompHeading from '../../components/CompHeading'
import CompCallToAction from '../../components/CompCallToAction'
import TeaserSolution from '../../components/Teaser/TeaserSolution'
import TeaserSolutionRight from '../../components/Teaser/TeaserSolutionRight'

// Graphics
import GraphicForecast from '../global/graphics/Img_Forecast.svg'
import GraphicSOP from '../global/graphics/SalesAndOperationsPlanning.svg'
import GraphicPP from '../global/graphics/Img_ProductionPlanning.svg'
import GraphicPersP from '../global/graphics/Img_Personal-Dienstplanung.svg'
import GraphicPurP from '../global/graphics/Img_Purchasing.svg'
import GraphicFP from '../global/graphics/IMG_FinancialPlanning.svg'

// Solutions
export default function Solutions() {
  return (
    <div className="Solutions-Content page-gap">
      <CompHeading
        Title={"Lösungen"}
        Subheading={"Unsere intelligenten Lösungen revolutionieren Ihre Supply Chain und Produktionsplanung."}
      />
      <TeaserSolution
        Title={"Forecast"}
        Subheading={"Bereits heute wissen, was morgen verkauft wird."}
        Graphic={GraphicForecast}
        GraphicAlt={"Aixioom Forecast"}
        ButtonText={"Zur Lösung"}
        ButtonLink={"/forecast"}
      />
      <TeaserSolutionRight
        Title={"Production Planning (PP)"}
        Subheading={"Intelligente Produktionsplanung für maximale Effizienz."}
        Graphic={GraphicPP}
        GraphicAlt={"Production Planning (PP)"}
        ButtonText={"Zur Lösung"}
        ButtonLink={"/production-planning"}
      />
      <TeaserSolution
        Title={"Sales- & Operations Planning (S&OP)"}
        Subheading={"Intelligente, effiziente Planung für nahtlose Abläufe."}
        Graphic={GraphicSOP}
        GraphicAlt={"Aixioom Sales- & Operations Planning (S&OP)"}
        ButtonText={"Zur Lösung"}
        ButtonLink={"/sales-and-operations-planning"}
      />
      <TeaserSolutionRight
        Title={"Human Resource Planning (HRP)"}
        Subheading={"Komplexe Dienstplanung mit KI im Griff behalten."}
        Graphic={GraphicPersP}
        GraphicAlt={"Human Resource Planning (HRP)"}
        ButtonText={"Zur Lösung"}
        ButtonLink={"/hr-planning"}
      />
      <TeaserSolution
        Title={"Einkaufsplanung"}
        Subheading={"KI-gestützte Einkaufsplanung durch Prognose der Bedarfe."}
        Graphic={GraphicPurP}
        GraphicAlt={"Einkaufsplanung"}
        ButtonText={"Zur Lösung"}
        ButtonLink={"/purchase-planning"}
      />
      <TeaserSolutionRight
        Title={"Finanzplanung"}
        Subheading={"Vorausschauende Finanzplanung durch KI."}
        Graphic={GraphicFP}
        GraphicAlt={"Finanzplanung"}
        ButtonText={"Zur Lösung"}
        ButtonLink={"/fincance-planning"}
      />
      <CompCallToAction
        Title={"Starten Sie noch heute mit Aixioom"}
        Subheading={"Kontaktieren Sie jetzt eine(n) unserer Expert*innen und fordern Sie eine individuelle Demo an."}
        ButtonText={"Kontakt"}
        ButtonLink={"/contact"}
      />
    </div>
  )
}
